<div
  class="flex flex-col mb-2 border-b border-gray-200 header-background h-20 p-2"
  >
  <div class="flex flex-row text-xs h-6">
    @for (b of breadcrumbs | async; track b; let i = $index) {
      <a
        class="last:text-gray-400 last:hover:text-gray-700 last:cursor-default hover:text-primary-700 text-gray-700 cursor-pointer"
        (click)="breadcrumbClicked(b)"
        >
        {{ b.text | i18n }}
        @if (i !== ((breadcrumbs | async) || []).length - 1) {
          <span
            class="text-gray-400"
            >
            &nbsp;>&nbsp;
          </span>
        }
      </a>
    }
  </div>
  <h1>{{ (title | async) || "" | i18n }}</h1>
  <!-- <div *ngIf="showResultCount | async" class="text-sm text-gray-700">
  {{
  {
  key: "foundXResults",
  values: [((algolia.observeTotalHitCount() | async) || 0) + ""]
  } | i18n
  }}
</div> -->
</div>
